import { render, staticRenderFns } from "./lesson-cancelled-notification.vue?vue&type=template&id=cbd76d74&scoped=true"
import script from "./lesson-cancelled-notification.vue?vue&type=script&lang=js"
export * from "./lesson-cancelled-notification.vue?vue&type=script&lang=js"
import style0 from "./lesson-cancelled-notification.vue?vue&type=style&index=0&id=cbd76d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd76d74",
  null
  
)

export default component.exports